export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-16 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-building-line"></i>
            关于平台
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            关于小草影院
          </h2>
        </div>

        <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/60">
          <div className="prose prose-sm max-w-none">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              <strong className="text-primary-600">小草影院</strong>是一个专注于电视剧高清全集在线观看的追剧平台。
              平台自上线以来，始终秉持"<strong>最新最全、高清流畅</strong>"的核心理念，
              致力于为广大追剧爱好者提供一站式观剧服务。我们每日同步各大卫视及网络平台最新热播剧集，
              涵盖国产剧、港台剧、日韩剧、欧美剧等十余种类型，拥有超过万部高清剧集资源。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              在技术层面，小草影院采用多线CDN全球加速与自适应码率技术，
              确保用户在各类网络环境下都能获得秒级加载、流畅不缓冲的观影体验。
              同时支持电脑、手机、平板等多端观看，真正实现随时随地高清追剧。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              小草影院始终关注用户体验，持续优化播放功能。目前已上线夜间模式、
              倍速播放、画质切换等实用功能，并同步推出iOS与安卓APP，让移动观影更加便捷。
              平台所有内容无需注册即可免费观看，真正做到即点即看。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              展望未来，小草影院将继续扩充内容库，引入更多优质剧集资源，
              持续提升播放技术与用户体验。我们期待成为每一位追剧爱好者最信赖的观影伙伴，
              让好剧不再难找，让追剧更加简单。
            </p>
          </div>

          {/* Stats row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200/60">
            {[
              { v: '10000+', l: '高清剧集' },
              { v: '50万+', l: '日均访问' },
              { v: '500+', l: '每日更新' },
              { v: '3年+', l: '稳定运营' },
            ].map((s) => (
              <div key={s.l} className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-500">{s.v}</div>
                <div className="text-xs text-foreground-400 mt-1">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}